import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const getPaymentReportPageContext = React.createContext({});
export let getPaymentReportPageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMPaymentReportPageGetContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getPaymentReportPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(getPaymentReportPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    getPaymentReportPageMachine,
    getPaymentReportPageState: state,
    getPaymentReportPageSend: send,
  };
};
